module.exports = __webpack_public_path__ + "frontend/images/landlords/landlords-best-quotes-xs-ffd2755b3521e6d612117415ac67db8a.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/landlords/landlords-best-quotes-xs.png
// module id = 376
// module chunks = 2